export enum GatewayKind {
  UNKNOWN = -1,
  VIRTUAL_VARIABLE = 0,
  MASTER = 1,
  OMNIA = 2,
  KNX = 10,
  CARD_PROGRAMMER_VIMAR_WCP = 20,
  CARD_PROGRAMMER_VIMAR_WCC = 21,
  CARD_PROGRAMMER_GEWISS = 22,
  CARD_PROGRAMMER_EELECTRON = 23,
  CARD_PROGRAMMER_SCHNEIDER = 24,
  CARD_PROGRAMMER_SIEMENS = 25,
  CARD_PROGRAMMER_MIFARE = 26,
  UI = 30,
  BTICINO_MY_HOME = 40,
  GSM = 50,
  CARD_PROGRAMMER_5577 = 60,
  CRESTRON = 70,
  ACCESS_CONTROL_KEYPAD = 80,
  MODBUS = 90,
  SIP_CLIENTS = 100,
  CLINOS = 110,
  MBUS = 120,
  BLUEWAVE = 130,
  DORMA_KABA_SAFLOK_6000 = 140,
  RTU_LOGGER = 150,
  INTESIS_WMP = 160,
  SALTO_IS = 170,
  INNO_EDGE_PLATE = 180,
  WIEGAND = 190,
  OPEN_ESCAPE_BUSINESS = 200,
  SAXOS = 210,
  EMPTY_TEMPLATE = 999,
  TELEGRAM = 220,
  PLATE_RECOGNIZER = 230,
  LORA = 240,
  BACNET = 250,
  ADS = 260,
  DAHUA = 270,
  MQTT = 280,
  ACCESS_CONTROL = 290,
  SECURITY = 300,
  NETWORK = 310,
  AURORA_GATEWAY = 320,
  OMIS_RFF = 330,
  SINAPSI = 350,
  AKUVOX = 380,
  VIRTUAL_KEY_MANAGER = 390,
}

/**
 * Handle gateay status
 */
export enum GatewayStatus {
  NOT_CONNECTED = 0,
  CONNECTING = 1,
  CONNECTED = 2,
  NOT_RESPONDING_TO_HELLO = 3,
  UNKNOW = 99,
}

export enum InfoCode {
  INFOCODE_OPERATION_NOT_SUPPORTED = 1000,
  INFOCODE_INFOCODE_NOT_SUPPORTED = 1001,
  INFOCODE_MASTERGATEWAY_NOT_CONNECTED = 2000,
  INFOCODE_FALCON_CONNECTION_NOT_OPENED = 10007,
  INFOCODE_GATEWAY_DEVICE_CONNECTION_BROKEN = 3000,
  INFOCODE_GATEWAY_DEVICE_CONNECTION_OK = 3001,
  INFOCODE_GATEWAY_WRITESETUP_ERROR = 4000,
  INFOCODE_GATEWAY_RELOADCONFIG_ERROR = 4501,
  INFOCODE_GATEWAY_RELOADSETTINGS_ERROR = 4502,
}

/**
 * Handle access control gateway subgroup
 */
export enum AccessControlGatewaySubgroup {
  ACCESS = 1,
  RESULT = 2,
  CUSTOMER_NAME = 3,
  LANGUAGE = 4,
  STATE = 5,
  GUEST_DATA = 6,
  TRANSIT = 7,
  SERVER_CONFIRMATION = 8,
}
